'use strict'

export default [
  {
   name:"Capture",
    fields: [
      { name:"title" },
      { name:"type",
        options:[
          {value:"change"},
          {value:"specification"},
          {value:"problem"}
        ]
      },
      {
        name:"description",
        height: 5
      }
    ]
  },
  { name: "Examine",
    fields:[
      {
        name: "impact",
        height:5
      },
      {
        name: "severity",
        options:[
          {value:1},
          {value:2},
          {value:3},
          {value:4},
          {value:5}
        ].reverse(),
        defaultValue:3
      },
      {
        name:"priority",

        options:[
          {value:1},
          {value:2},
          {value:3},
          {value:4},
          {value:5}
        ].reverse(),
        defaultValue:3
      }
    ]
  },
  { name: "Propose",
    fields: [
      {
        name:"options",
        optional:true, height: 5
      },
      {
        name:"recommendation",
        height: 5
      },
      {
        name:"lessonSummary",
        height: 5,
        optional: true,
      }
    ]
  },
  {
    name: "Decide",
    fields: [
      {
        name:"decision",
        height:5
      },
      {
        name:"decidedBy",
      }
    ]
  },
  {
    name: "Implement",
    fields: [
      { name:"status", options:[ {value:"Active"},{value:"Closed"}] },
      { name:"statusDescription", height:5 }
  ] }
];



// WEBPACK FOOTER //
// ./views/change/formDefinition.js